import { createMuiTheme } from '@material-ui/core/styles';
import { primary, secondary, danger } from './Colors';

const mainTheme = createMuiTheme({
  palette: {
    primary: {
      main: primary.main,
    },
    secondary: {
      main: secondary.main,
    },
    danger: {
      main: danger.main,
    },
  },
});
export default mainTheme;
